var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderBreadcrumb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 19
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11455",
    d: "M1.5.01s2.484-.012 5.751-.012c1.782-.08 2.64 1.649 3.489 2.6H22.5a1.389 1.389 0 011.5 1.3v13.591a1.505 1.505 0 01-1.5 1.509h-21A1.505 1.505 0 010 17.489V1.521A1.505 1.505 0 011.5.01z",
    fill: "#61c8fa"
  })));
}
export default SvgFolderBreadcrumb;